// extracted by mini-css-extract-plugin
export var active = "_hw-7";
export var blink = "_hw-8";
export var dropDownSelector = "_hw-4";
export var dropDownWrapper = "_hw-3";
export var fakeCursor = "_hw-6";
export var fontSizeButton = "_hw-9";
export var formQuillEditor = "_hw-0";
export var pressed = "_hw-a";
export var qlBlank = "_hw-1";
export var textFormattingToolbar = "_hw-2";
export var textToolbarOption = "_hw-5";